export default __webpack_public_path__ + "static/media/header.44c15bd1.jpeg";